<template>
  <card>
    <slot slot="header">
      <v-toolbar-title>
        <v-icon>person</v-icon>
        Bem Vindo
      </v-toolbar-title>
    </slot>

    <slot slot="body">
      <v-form>
        <v-container grid-list-lg fluid>
          <v-layout row justify-center align-center wrap>
            <v-flex xs12>
              <v-text-field
                prepend-icon="person"
                name="name"
                label="Nome"
                type="text"
                autofocus
                v-model="user.name"
                :error-messages="errors.collect('name')"
                v-validate="'required'"
                data-vv-as="Nome"
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field
                prepend-icon="mail"
                name="mail"
                label="E-mail"
                type="text"
                v-model="user.email"
                :error-messages="errors.collect('mail')"
                v-validate="'required|email|verify_email'"
                data-vv-as="E-mail"
                data-vv-delay="1000"
              />
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field
                prepend-icon="lock"
                name="password"
                label="Senha"
                id="password"
                type="password"
                v-model="user.password"
                :error-messages="errors.collect('password')"
                v-validate="'required|min:6'"
                data-vv-as="Senha"
              />
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field
                prepend-icon="check"
                name="confirmation"
                label="Confirmação"
                id="confirmation"
                type="password"
                v-model="user.confirmation"
                :error-messages="errors.collect('confirmation')"
                v-validate="'required|min:6'"
                data-vv-as="Confirmação"
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field
                prepend-icon="check"
                name="codigo"
                label="Código"
                id="codigo"
                type="password"
                v-model="codigo"
                :error-messages="errors.collect('codigo')"
                data-vv-validate-on="blur"
                v-validate="'required'"
                @keyup.native.enter="register()"
                data-vv-as="Código"
              />
            </v-flex>
            <v-flex xs12 class="text-xs-center">
              <v-snackbar
                :top="true"
                :right="true"
                :timeout="6000"
                v-model="snackbar.active"
                :color="snackbar.color"
              >
                {{ snackbar.text }}
                <v-btn flat @click.native="snackbar = false">Fechar</v-btn>
              </v-snackbar>
              <v-btn dark class="gradient" @click="register()" :loading="loading">Registrar</v-btn>
              <v-btn flat href="#/">Voltar</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </slot>
  </card>
</template>

<style scoped>
.gradient {
  background: linear-gradient(40deg, #4a97ce, #5fbf8d);
}
</style>

<script>
import Card from "../shared/Card";
import { Validator } from "vee-validate";

export default {
  components: { Card },
  data: () => ({
    codigo: "",
    loading: false,
    user: {
      name: "",
      email: "",
      password: "",
      confirmation: "",
    },
    snackbar: {
      active: false,
      text: "Solicitação realizada com sucesso",
      color: "success",
    },
  }),
  props: {
    source: String,
  },
  created() {
    Validator.extend("verify_email", {
      getMessage: (field) => `The ${field} is already registered.`,
      validate: (value) =>
        new Promise((resolve) => {
          this.$http.get(`auth/check_user`, { params: { email: this.user.email } }).then((res) => {
            resolve({
              valid: res.body.length === 0,
            });
          });
        }),
    });
  },
  methods: {
    register: function () {
      if (this.codigo !== "codigoimpostoderenda123") {
        alert("Código errado!");
        return 0;
      }
      if (this.user.password !== this.user.confirmation) {
        alert("A senha e a confirmação devem ser iguais!");
        return 0;
      }
      this.loading = true;
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.snackbar.active = true;
          this.$auth.register({
            body: this.user,
            autoLogin: true,
            rememberMe: true,
            success: function (res) {
              this.snackbar = {
                active: true,
                text: "Solicitação realizada com sucesso",
                color: "success",
              };
              this.loading = false;
            },
            error: function (res) {
              this.snackbar = {
                active: true,
                text: "Solicitação falhou",
                color: "error",
              };
              this.loading = false;
            },
            redirect: "/home",
          });
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/auth/Register.vue